//Import Styles
import '../styles/faq.css';

//React imports
import React, { useState } from 'react';

//Import components
import Faq from '../components/Faq';
import { NavLink } from 'react-router-dom';

const Technology = () => {
  //Set a state for the FAQs
  const [faqs, setFaqs] = useState([
    {
      question: 'What is an NFT? Is it a cryptocurrency?',
      answer: `Technology......Non-Fungible Tokens are unique, easily verifiable digital assets that
      can reprrd. But a bitcoin is indistinguishable from another
      bitcoin.`,
      id: 1,
    },
    {
      question: 'Why would I want to own an NFT? Can I make money on it?',
      answer: `One reason to buy an NFT is for its emotional value, which isn’t so
      different from physical objects...unless you’re a total utilitarian.
      No one buys lip gloss because they need it. They buy it for the way it
      makes them feel. The same can be true for a GIF, image, video, or
      other digital asset. The other reason is because you think it’s
      valuable...and will only increase in value. And yes, you can make
      money off of an NFT by buying and reselling it for more.`,
      id: 2,
    },
    {
      question: 'How do you buy an NFT?',
      answer: `The process varies based on what platform you use. And there are a lot
      of platforms. On Top Shot for instance, you register to join a
      waitlist that can be thousands of NBA fans long. When a digital asset
      goes on sale, you’re randomly chosen to buy it. While Top Shot accepts
      USD as well as crypto, some platforms only accept cryptocurrencies,
      like OpenSea.`,
      id: 3,
    },
    {
      question: 'How do you know your NFT is authentic?',
      answer: `NFT ownership is recorded on the blockchain, and that entry acts as a
      digital pink slip. Defining the blockchain is a whole ‘nother can of
      worms that you can read about here. Where is the blockchain? It’s
      decentralized, so it exists across many people’s computers in
      encrypted bits and pieces.`,
      id: 4,
    },
    {
      question: 'Are NFTs new?',
      answer: `They’re newly popular, but not new. Andrew Steinwold traces their
      origins all the way back to blockchain-backed Colored Coins in 2012,
      but they didn’t move into the mainstream until CryptoKitties had
      everyone buying virtual cats in 2017. Recently, as Google search
      trends indicate, interest in NFTs has exploded. The creators of
      CryptoKitties started Top Shot, a platform that allows fans to buy,
      sell, and trade NBA highlights, and digital artwork is now being
      auctioned by Christie’s.`,
      id: 5,
    },

    {
      question: 'More Information',
      answer: `Bitcoin’s primary use is as a virtual currency and store of value.`,
      id: 6,
    },
    {
      question: '',
      answer: `Ethereum: is often referred to as the second most popular cryptocurrency, after Bitcoin. `,
      id: 7,
    },

    {
      question: '',
      answer: `Blockchain: an open distributed ledger that records transactions.`,
      id: 8,
    },

    {
      question: '',
      answer: `NFT: A non-fungible token is a non-interchangeable unit of data stored on a blockchain, a form of digital ledger. `,
      id: 9,
    },
    {
      question: '',
      answer: `OpenSea: the largest NFT marketplace.`,
      id: 10,
    },

    {
      question: '',
      answer: `Solidity: is an object-oriented, high-level language for implementing smart contracts.`,
      id: 12,
    },

    {
      question: '',
      answer: ` CryptoCurrency: is a medium of exchange that is digital, encrypted and decentralized.  `,
      id: 13,
    },

    {
      question: '',
      answer: ` CryptoCurrency: No central authority manages or maintains cryptocurrency value. Value is broadly distributed among a cryptocurrency's users via the internet. `,
      id: 14,
    },

    {
      question: '',
      answer: ` Crypto: you can buy regular goods and services.  `,
      id: 15,
    },

    {
      question: '',
      answer: ` Asset Class: can be a investment, like stocks or precious metals, but also can be risky. `,
      id: 16,
    },

    {
      question: '',
      answer: ` Crypto Wallet: money transfer, account, by telephone number, or QR code. `,
      id: 17,
    },

    {
      question: '',
      answer: ` Common Coins: Bitcoin, Ethereum and Dogecoin. `,
      id: 18,
    },

    {
      question: '',
      answer: ` Best Crypto Exchanges:  January 2022, 		Binance.US. `,
      id: 19,
    },

    {
      question: '',
      answer: ` Beginner Exchanges: CoinBase. `,
      id: 20,
    },

    {
      question: '',
      answer: ` More Exchanges: bitFlyer, 	Bitstamp, Bittrex, Global, Crypto.com, Gate.io, Gemini, Kraken, KuCoin. `,
      id: 21,
    },

    {
      question: '',
      answer: ` Exchange transaction fees, dependent on your purchase amount with convenience fee of 0.5%. `,
      id: 22,
    },
  ]);

  return (
    <div className="faqWrapper">
      <h1 className="faqTitle">Software Technologies</h1>
      <div className="darkGlassCard faqContainer">
        <div className="space"> </div>
        <div className="space"> </div>
        <div className="scroll-container">
          <div className="scroll-text">
            My Latest ReactJS Website Technologies
          </div>
        </div>
        <>
          <div className="space"> </div>
          <div className="space"> </div>
          {/* <div className="linkcenter">
            <NavLink to="/React" className={`navMenuItem`}>
              ReactJS
            </NavLink>
            <NavLink to="/React2" className={`navMenuItem`}>
              CSS3
            </NavLink>
            <NavLink to="/Products" className={`navMenuItem`}>
              Firebase
            </NavLink>
            <NavLink to="/Technology" className={`navMenuItem`}>
              NextJS
            </NavLink>
          </div> */}
          <div className="space"> </div>
          <div className="space"> </div>
        </>
        {/* //Map through the FAQs and display them */}
        {faqs.map((faq) => {
          return (
            <Faq key={faq.id} question={faq.question} answer={faq.answer} />
          );
        })}

        <div className="space"> </div>
        <div className="space"> </div>
        <div className="linkcenter">
          <div className="space"> </div>
          <div className="space"> </div>
        </div>
      </div>
    </div>
  );
};

export default Technology;
